import {
    AfterViewInit,
    Component,
    ElementRef,
    OnDestroy,
    OnInit
} from '@angular/core';

@Component({
    selector: 'app-testimonials',
    templateUrl: './testimonials.component.html',
    styleUrls: ['./testimonials.component.scss']
})
export class TestimonialsComponent
    implements OnInit, AfterViewInit, OnDestroy {

    private observer?: IntersectionObserver;

    constructor(
        private hostElement: ElementRef<HTMLElement>
    ) {}

    ngOnInit(): void {}

    ngAfterViewInit(): void {
        this.initScrollReveal();
    }

    ngOnDestroy(): void {
        this.observer?.disconnect();
    }

    private initScrollReveal(): void {
        const host = this.hostElement.nativeElement;

        const elements = Array.from(
            host.querySelectorAll<HTMLElement>('[data-reveal]')
        );

        if (!elements.length) {
            return;
        }

        if (
            typeof window === 'undefined' ||
            typeof IntersectionObserver === 'undefined'
        ) {
            elements.forEach((el) => {
                el.classList.add('reveal-visible');
            });
            return;
        }

        elements.forEach((element) => {
            element.classList.remove('reveal-visible');
            element.classList.add('reveal-hidden');

            const delay = element.getAttribute('data-reveal-delay');
            if (delay) {
                const delayNumber = parseInt(delay, 10);
                if (!Number.isNaN(delayNumber)) {
                    element.style.setProperty(
                        '--reveal-delay',
                        `${delayNumber}ms`
                    );
                }
            }
        });

        this.observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting) {
                        return;
                    }

                    const element = entry.target as HTMLElement;
                    element.classList.remove('reveal-hidden');
                    element.classList.add('reveal-visible');

                    this.observer?.unobserve(element);
                });
            },
            {
                threshold: 0.1,
                rootMargin: '0px 0px -30px 0px'
            }
        );

        elements.forEach((element) => {
            this.observer?.observe(element);
        });
    }
}
